import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Employee } from "../../../Controllers/Types/EmployeeInterface";
import { baseURL } from "../../../Api/ApiConstant";
import { checkEmail, checkFileImage, checkPhoneNumber, checkText } from "../../../Utils/Validator";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { employeeCompanyUpdateAPI, contactDeleteAPI, employeePersonalUpdateAPI, employeeRoleUpdateAPI, roleCreateAPI, roleDataGetAPI, createAreaForContact, deleteAreaForContact, updateAreaForContact } from "../../../Api/ContactApi";
import { fetchAllContactAfterEditEmployeeDetails } from "../../../Controllers/Thunks/contactThunks";
import { Role, mapRoles } from "../../../Controllers/Types/UserRoleInterface";
import { imageFileExtension } from "../../../Api/FileConstant";
import { goToTop } from "../../../Components/goToTop";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import { RootState } from "../../../Controllers/Store";
import ErrorPage from "../../../Components/ErrorPage";
import { setSelectedEmployee } from "../../../Controllers/Slices/contactSlice";
import EmailSearchDialog from "../EmailSearchDialog";
import { EmployeeAreaList } from "../../../Controllers/Types/EmployeeInterface";
import { getContactAreaList } from "../../../Controllers/Thunks/contactThunks";
import TextInput from "../../../Components/TextInput";

const ViewEmployeeContact: React.FC = () => {
    //const employee = (location.state as { employee: Employee })?.employee;
    const location = useLocation();
    const employeeDetails = location.state?.employee as Employee;

    const employee = useAppSelector(state => state.contact.selectedEmployee);
    const areaList = useAppSelector((state) => state.contactAreaList.areaList);
    const dispatch = useAppDispatch()

    const toast = useRef<Toast>(null);
    const navigate = useNavigate();

    const [tab, setTab] = useState<'personal' | 'company' | 'role'>('personal');
    const [loading, setLoading] = useState<boolean>(false);
    const [showAddData, setShowAddData] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    //Personal form variables
    const [profileImage, setProfileImage] = useState<string | null>(null);
    const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [mobile, setMobile] = useState<string>('');
    const [landline, setLandline] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');

    //Company form variables
    const [companyPersonalEmail, setCompanyPersonalEmail] = useState<string>('');
    const [companyPersonalPhone, setCompanyPersonalPhone] = useState<string>('');
    const [companyName, setCompanyName] = useState<string>('');
    const [companyRegNo, setCompanyRegNo] = useState<string>('');
    const [companyEmail, setCompanyEmail] = useState<string>('');
    const [companyPhone, setCompanyPhone] = useState<string>('');
    const [companyLandline, setCompanyLand] = useState<string>('');
    const [companyAddress, setCompanyAddress] = useState<string>('');
    const [companyCity, setCompanyCity] = useState<string>('');
    const [companyPostCode, setCompanyPostCode] = useState<string>('');

    const [selectedRole, setSelectedRole] = useState<Role | null>(null);
    const [displayRoleName, setDisplayRoleName] = useState<string>('');

    const [selectedRoleError, setSelectedRoleError] = useState<string>('');
    const [displayRoleNameError, setDisplayRoleNameError] = useState<string>('');

    const [roleList, setRoleList] = useState<Role[]>([]);

    const [addRoleName, setAddRoleName] = useState<string>('');
    const [addRoleNameError, setAddRoleNameError] = useState<string>('');


    //Error Personal
    const [errorProfileImageFile, setErrorProfileImageFile] = useState<string>('');
    const [firstNameError, setFirstNameError] = useState<string>('');
    const [lastNameError, setLastNameError] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [mobileError, setMobileError] = useState<string>('');
    const [landlineError, setLandlineError] = useState<string>('');
    const [addressError, setAddressError] = useState<string>('');
    const [cityError, setCityError] = useState<string>('');
    const [postCodeError, setPostCodeError] = useState<string>('');

    //Error Company
    const [companyPersonalEmailError, setCompanyPersonalEmailError] = useState<string>('');
    const [companyPersonalPhoneError, setCompanyPersonalPhoneError] = useState<string>('');
    const [companyNameError, setCompanyNameError] = useState<string>('');
    const [companyRegNoError, setCompanyRegNoError] = useState<string>('');
    const [companyEmailError, setCompanyEmailError] = useState<string>('');
    const [companyPhoneError, setCompanyPhoneError] = useState<string>('');
    const [companyLandlineError, setCompanyLandError] = useState<string>('');
    const [companyAddressError, setCompanyAddressError] = useState<string>('');
    const [companyCityError, setCompanyCityError] = useState<string>('');
    const [companyPostCodeError, setCompanyPostCodeError] = useState<string>('');
    const [isDefaultProfileImage, setIsDefaultProfileImage] = useState<boolean>(false);
    const [employeeType, setEmployeeType] = useState<string>('');
    const [showSearchEmailModal, setShowSearchEmailModal] = useState<boolean>(false);

    const [filteredAreaListData, setFilteredAreaListData] = useState<EmployeeAreaList[]>([]);
    const [selectedArea, setSelectedArea] = useState<EmployeeAreaList | null>(null);

    const [showAreaModal, setShowAreaModal] = useState<boolean>(false);
    const [areaSearchKey, setAreaSearchKey] = useState<string>("");
    const [customAreaName, setCustomAreaName] = useState<string>("");
    const [customAreaNameError, setCustomAreaNameError] = useState<string>("");

    const [selectedAreaId, setSelectedAreaId] = useState<number | null>(null);
    const [showAreaEditModal, setShowAreaEditModal] = useState<boolean>(false);
    const [areaName, setAreaName] = useState<string>('');
    const [areaNameError, setAreaNameError] = useState<string>('');
    const [errorArea, setErrorArea] = useState<string>('');
    const [customCreateLoading, setCustomCreateLoading] = useState<boolean>(false);

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionAdd = useCanEdit('Contact', 'add')
    const isPermissionUpdate = useCanEdit('Contact', 'update')
    const isPermissionDelete = useCanEdit('Contact', 'delete')

    useEffect(() => {
        dispatch(setSelectedEmployee(employeeDetails));
    }, [employeeDetails]);

    //For image upload/change
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setProfileImage(event.target.result);
                    const file = e.target.files?.[0];
                    setProfileImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    // 

    // For clear image
    const clearImage = () => {
        setProfileImage(null);
        setProfileImageFile(null);
    };
    // 

    function checkCredentials(): boolean {
        const isFirstNameValid = checkText(firstName, true, setFirstNameError)
        const isLastNameValid = checkText(lastName, (employeeType === 'Employee' ? true : false), setLastNameError)
        const isEmailValid = checkEmail(email, (employeeType === 'Employee' ? true : false), setEmailError)
        const isMobileValid = checkPhoneNumber(mobile, (employeeType === 'Temporary Employee' ? true : false), setMobileError)
        const isLandlineValid = checkPhoneNumber(landline, false, setLandlineError)
        const isAddressValid = checkText(address, (employeeType === 'Employee' ? true : false), setAddressError)
        const isCityValid = checkText(city, (employeeType === 'Employee' ? true : false), setCityError)
        const isPostCodeValid = checkText(postCode, (employeeType === 'Employee' ? true : false), setPostCodeError)
        const isFileValid = checkFileImage(profileImageFile!, false, setErrorProfileImageFile);

        return isFirstNameValid && isLastNameValid && isEmailValid && isMobileValid && isAddressValid && isCityValid && isPostCodeValid && isLandlineValid && isFileValid;
    }

    function checkCredentialsCompany(): boolean {
        const isCompanyPersonalEmailValid = checkEmail(companyPersonalEmail, false, setCompanyPersonalEmailError)
        const isCompanyPersonalPhoneValid = checkPhoneNumber(companyPersonalPhone, false, setCompanyPersonalPhoneError)
        const isCompanyNameValid = checkText(companyName, true, setCompanyNameError)
        const isCompanyRegNoValid = checkText(companyRegNo, true, setCompanyRegNoError)
        const isCompanyEmailValid = checkEmail(companyEmail, true, setCompanyEmailError)
        const isCompanyPhoneValid = checkPhoneNumber(companyPhone, true, setCompanyPhoneError)
        const isCompanyAddressValid = checkText(companyAddress, true, setCompanyAddressError)
        const isCompanyCityValid = checkText(companyCity, true, setCompanyCityError)
        const isCompanyPostCodeValid = checkText(companyPostCode, true, setCompanyPostCodeError)

        return isCompanyPersonalEmailValid && isCompanyPersonalPhoneValid && isCompanyNameValid && isCompanyRegNoValid && isCompanyEmailValid && isCompanyPhoneValid && isCompanyAddressValid && isCompanyCityValid && isCompanyPostCodeValid;
    }

    function checkCredentialsRole(): boolean {
        let isSelectedRoleValid: boolean = false

        if (selectedRole !== undefined) {
            isSelectedRoleValid = true;
            setSelectedRoleError('')
        } else {
            setSelectedRoleError('This field is required.')
        }
        const isDisplayRoleNameValid = checkText(displayRoleName, true, setDisplayRoleNameError)
        return isSelectedRoleValid && isDisplayRoleNameValid;
    }


    // For Update Personal Details
    const handleUpdatePersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true)
            const res = await employeePersonalUpdateAPI(employee!.id, firstName, lastName, email, mobile, landline, address, city, postCode, profileImageFile!, selectedArea?.id!);
            setLoading(false)
            if (res.status) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Personal details updated successfully.',
                        life: 3000
                    });
                }

                dispatch(fetchAllContactAfterEditEmployeeDetails());
                setShowEditModal(false);
                clearImage();
            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        showAPIErrorPersonalData(key, value[0])
                    ))
                }
            }
        }
    }

    // 

    // For Update Company Details
    const handleUpdateCompanyDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsCompany()) {
            setLoading(true)
            const res = await employeeCompanyUpdateAPI(employee!.companyId, companyPersonalEmail, companyPersonalPhone, companyName, companyRegNo, companyEmail, companyPhone, companyAddress, companyCity, companyPostCode, '');
            setLoading(false)
            if (res.status) {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Company details updated successfully.',
                        life: 3000
                    });
                }

                dispatch(fetchAllContactAfterEditEmployeeDetails());

                setShowEditModal(false);

            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        showAPIErrorComapanyData(key, value[0])
                    ))
                }
            }

        }

    }
    // 

    // For Update Role Details
    const handleUpdateRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsRole()) {
            setLoading(true);
            const res = await employeeRoleUpdateAPI(employee!.user_role_info_id, selectedRole!.id, displayRoleName);
            setLoading(false)
            if (res.status) {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role details updated successfully.',
                        life: 3000
                    });
                }

                dispatch(fetchAllContactAfterEditEmployeeDetails());

                setShowEditModal(false);

            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        setDisplayRoleNameError(value[0])
                    ))
                }
            }

        }
    }
    // 

    function showAPIErrorPersonalData(keyName: string, error: string): void {

        if (keyName === "email") {
            setEmailError(error);
        }
        if (keyName === "mobile") {
            setMobileError(error);
        }
        if (keyName === "landline") {
            setLandlineError(error);
        }
        if (keyName === "profile_image") {
            setErrorProfileImageFile(error);
        }
    }

    function showAPIErrorComapanyData(keyName: string, error: string): void {

        if (keyName === "personal_email") {
            setCompanyPersonalEmailError(error);
        }
        if (keyName === "personal_phone") {
            setCompanyPersonalPhoneError(error);
        }
        if (keyName === "regno") {
            setCompanyRegNoError(error);
        }
        if (keyName === "email") {
            setCompanyEmailError(error);
        }
        if (keyName === "phone") {
            setCompanyPhoneError(error);
        }

    }

    function checkCredentialsRoleCreate(roleName: string): boolean {
        const isRoleNameValid = checkText(roleName, true, setAddRoleNameError);

        return isRoleNameValid;
    }

    // For create custom role
    const handleAddRole = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsRoleCreate(addRoleName)) {
            const data = await roleCreateAPI(addRoleName, localStorage.getItem('token') || '');

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        setAddRoleNameError(value[0])
                    ))
                }
            } else {
                /* clear data */
                setAddRoleName('');
                setShowAddData(false)
                /* call call data function */
                roleDataGet();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role created successfully.',
                        life: 3000
                    });
                }
            }
        }
    };

    //for Delete contact
    const handleDeleteContact = async (e: React.FormEvent) => {
        confirmDialog({
            message: 'Are you sure you want to delete the employee details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: deleteContact,
        });
    };

    const deleteContact = async () => {
        const res = await contactDeleteAPI(employee!.contactId);

        if (res.status) {

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Employee deleted successfully.',
                    life: 3000
                });
            }

            setShowEditModal(false);

            setTimeout(() => {
                navigate('/contact');
            }, 500);

        } else {
            if (res.statusCode === 422) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Employee deleted failed.',
                        life: 3000
                    });
                }
            }
        }
    }
    // 

    const selectedRoleTemplate = (option: Role, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    <div>{option ? option.role_name : 'Select role'}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const roleOptionTemplate = (option: Role) => {
        return (
            <div className="d-flex align-items-center">
                <div>{option.role_name}</div>
            </div>
        );
    };

    const switchTabs = (tab: 'personal' | 'company' | 'role') => {
        setTab(tab);
        goToTop();
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    }

    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    const roleDataGet = async () => {

        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(mapRoles(data.data || []) || []);
            //setRole(mapRoles(data.data || [])[0])
        }
    }

    useEffect(() => {
        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);

    useEffect(() => {
        roleDataGet();
    }, [])

    useEffect(() => {
        if (employee) {
            setProfileImage(baseURL + employee.profile_image);
            setFirstName(employee.first_name);
            setLastName(employee.last_name);
            setEmail(employee.email);
            setMobile(employee.mobile);
            setLandline(employee.landline);
            setAddress(employee.address);
            setCity(employee.city);
            setPostCode(employee.post_code);

            setCompanyPersonalEmail(employee.personal_email);
            setCompanyPersonalPhone(employee.personal_phone);
            setCompanyName(employee.companyName);
            setCompanyRegNo(employee.regno);
            setCompanyEmail(employee.company_email);
            setCompanyPhone(employee.company_phone);
            setCompanyAddress(employee.company_address);
            setCompanyCity(employee.company_city);
            setCompanyPostCode(employee.company_post_code);

            setSelectedRole({ id: employee.user_role_id, role_name: employee.role_name })
            setDisplayRoleName(employee.display_role_name);

            setEmployeeType(employee?.contactSubType);

            if (employee?.profile_image) {
                const fileName = employee?.profile_image.split('/').pop();

                if (fileName === 'user.png') {
                    setIsDefaultProfileImage(true);
                } else {
                    setIsDefaultProfileImage(false);
                }
            } else {
                setIsDefaultProfileImage(false);
            }
            if(employee.area_list && employee.area_list!.length > 0){
                setSelectedArea(employee.area_list[0])
            }
            
        }
    }, [employee]);


    /* Edit modal component */
    const editModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5" id="contactEditModalLabel">
                {tab === 'personal' ?
                    "Edit Personal detail" :
                    tab === 'company' ?
                        "Edit Company detail" :
                        tab === 'role' ?
                            "Edit Role detail" :
                            null
                }
            </h5>
            {isPermissionDelete && <button type="button" className="data_delete_btn p-ripple"
                onClick={handleDeleteContact}>
                <i className="bi bi-trash3"></i>
                <Ripple />
            </button>}
        </div>
    );

    const editModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={() => setShowEditModal(false)} />

            {tab === 'personal' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdatePersonalDetails} loading={loading} className="custom_btn primary" />
            ) : tab === 'company' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateCompanyDetails} loading={loading} className="custom_btn primary" />
            ) : tab === 'role' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateRoleDetails} loading={loading} className="custom_btn primary" />
            ) : null
            }
        </div>
    )
    /* */

    const onEmailConfirm = (email: string) => {
        setEmail(email);
        setShowSearchEmailModal(false);
    }


    /* Clear validation messages */
    // Personal
    useEffect(() => {
        checkText(firstName, false, setFirstNameError)
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setLastNameError);
    }, [lastName]);

    useEffect(() => {
        checkEmail(email, false, setEmailError)
    }, [email]);

    useEffect(() => {
        checkPhoneNumber(mobile, false, setMobileError)
    }, [mobile]);

    useEffect(() => {
        checkPhoneNumber(landline, false, setLandlineError)
    }, [landline]);

    useEffect(() => {
        checkText(address, false, setAddressError)
    }, [address]);

    useEffect(() => {
        checkText(city, false, setCityError)
    }, [city]);

    useEffect(() => {
        checkText(postCode, false, setPostCodeError)
    }, [postCode]);

    useEffect(() => {
        checkFileImage(profileImageFile!, false, setErrorProfileImageFile);
    }, [profileImageFile]);
    // 

    // Company
    useEffect(() => {
        checkEmail(companyPersonalEmail, false, setCompanyPersonalEmailError)
    }, [companyPersonalEmail]);

    useEffect(() => {
        checkPhoneNumber(companyPersonalPhone, false, setCompanyPersonalPhoneError)
    }, [companyPersonalPhone]);

    useEffect(() => {
        checkText(companyName, false, setCompanyNameError)
    }, [companyName]);

    useEffect(() => {
        checkText(companyRegNo, false, setCompanyRegNoError)
    }, [companyRegNo]);

    useEffect(() => {
        checkEmail(companyEmail, false, setCompanyEmailError)
    }, [companyEmail]);

    useEffect(() => {
        checkPhoneNumber(companyPhone, false, setCompanyPhoneError)
    }, [companyPhone]);

    useEffect(() => {
        checkText(companyAddress, false, setCompanyAddressError)
    }, [companyAddress]);

    useEffect(() => {
        checkText(companyCity, false, setCompanyCityError)
    }, [companyCity]);

    useEffect(() => {
        checkText(companyPostCode, false, setCompanyPostCodeError)
    }, [companyPostCode]);

    // Role
    useEffect(() => {
        if (selectedRole !== null || selectedRole !== undefined) {
            setSelectedRoleError('');
        }
    }, [selectedRole]);

    useEffect(() => {
        checkText(displayRoleName, false, setDisplayRoleNameError)
    }, [displayRoleName]);

    useEffect(() => {
        checkText(addRoleName, false, setAddRoleNameError);
    }, [addRoleName]);
    // 

    /* For area */
    useEffect(() => {
        if (areaList && areaList?.length === 0) {
            dispatch(getContactAreaList());
        }
    }, [areaList, dispatch]);

    useEffect(() => {
        if (areaList && areaList?.length > 0) {
            const filteredData = areaList.filter((area) =>
                area?.area_name!.toLowerCase().includes(areaSearchKey.toLowerCase())
            );

            setFilteredAreaListData(filteredData);
        } else {
            setFilteredAreaListData([]);
        }
    }, [areaList, areaSearchKey]);

    const handleCloseAreaModal = () => {
        setShowAreaModal(false);
        setAreaSearchKey("");

        handleClearCustomAreaFields();
    };

    const handleClearCustomAreaFields = () => {
        setCustomAreaName('');
        setCustomAreaNameError('');
    }

    const handleAddArea = () => {
        setShowAreaModal(true);
    };

    const handleSelectArea = (area: EmployeeAreaList) => {
        setSelectedArea(area);

        setTimeout(() => {
            handleCloseAreaModal();
        }, 200);
    }

    // for database error
    function showAPIErrorAreaAdd(keyName: string, error: string): void {
        if (keyName === "area_name") {
            setCustomAreaNameError(error);
        }
    }

    // for database error
    function showAPIErrorAreaUpdate(keyName: string, error: string): void {
        if (keyName === "area_name") {
            setAreaNameError(error);
        }
    }

    useEffect(() => {
        setCustomAreaNameError('');
    }, [customAreaName]);

    useEffect(() => {
        setAreaNameError('');
    }, [areaName]);

    const handleCreateArea = async (e: React.FormEvent) => {
        e.preventDefault();

        setCustomCreateLoading(true);
        const data = await createAreaForContact(
            customAreaName
        );
        if (data.statusCode === 200) {
            // call dispach event
            dispatch(getContactAreaList());
            setCustomCreateLoading(false);
            handleClearCustomAreaFields();
            if (toast.current) {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Area created successfully.",
                    life: 3000,
                });
            }
        } else if (data.statusCode === 422) {
            setLoading(false);

            Object.entries(data.errors ?? []).map(([key, value], index) => (
                showAPIErrorAreaAdd(key, value[0])
            ));
        } else {
            setCustomCreateLoading(false);
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error creating the area.",
                    life: 3000,
                });
            }
        }
    };

    const handleCloseAreaEditModal = () => {
        setShowAreaEditModal(false);
        setAreaName('');
        setAreaNameError('');
        setSelectedAreaId(null);
    }

    const handleEditArea = (area: EmployeeAreaList) => {
        setShowAreaEditModal(true);
        setAreaName(area?.area_name);
        setSelectedAreaId(area?.id);
    };

    const handleUpdateArea = async (e: React.FormEvent) => {
        e.preventDefault();

        setLoading(true);
        const data = await updateAreaForContact(
            selectedAreaId!,
            areaName
        );
        if (data.statusCode === 200) {
            // call dispach event
            dispatch(getContactAreaList());
            setLoading(false);
            handleCloseAreaEditModal();
            if (toast.current) {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Area updated successfully.",
                    life: 3000,
                });
            }
        } else if (data.statusCode === 422) {
            setLoading(false);

            Object.entries(data.errors ?? []).map(([key, value], index) => (
                showAPIErrorAreaUpdate(key, value[0])
            ));
        } else {
            setLoading(false);
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error updating the area.",
                    life: 3000,
                });
            }
        }
    };

    const handleDeleteArea = (areaId: number) => {
        confirmDialog({
            message: 'Are you sure you want to delete this area',
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteArea(areaId),
            dismissableMask: true,
            resizable: false,
            draggable: false,
        });
    }

    const deleteArea = async (areaId: number) => {
        try {
            const data = await deleteAreaForContact(areaId);
            if (data.statusCode === 200) {
                // call dispach event
                dispatch(getContactAreaList());
                handleCloseAreaEditModal();
                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Area deleted successfully.",
                        life: 3000,
                    });
                }
            }

        } catch (error) {
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error deleting the area.",
                    life: 3000,
                });
            }
        }
    }

    const areaEditModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Edit area
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={() => handleDeleteArea(selectedAreaId!)}>
                <i className="bi bi-trash3"></i>
                <Ripple />
            </button>
        </div>
    );

    const areaEditModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseAreaEditModal}
            />

            <Button
                label={`${loading ? "Processing" : "Update"}`}
                onClick={handleUpdateArea}
                loading={loading}
                className="custom_btn primary"
            />
        </div>
    );

    return (
        <React.Fragment>
            <Toast ref={toast} />
            <div className="main_content layout_padding show_side_bar">
                {(!employee) ? (
                    <ErrorPage
                        errorMessage="There was an error retrieving the selected employee details."
                    />
                ) : (
                    <React.Fragment>
                        <div className="main_head_area">
                            <h4 className="main_heading">View Contact</h4>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_content mt-0">
                            <div className="page_body_area">
                                <div className="row">
                                    <div className="col-12 col-xl-4 mx-auto page_divider custom_height" style={{ minHeight }}>
                                        <div className="profile_view_area mt-2 mt-sm-0 mb-4 mb-sm-0">
                                            <div className="profile_view_main_area">
                                                <Image
                                                    className="profile_img_area"
                                                    src={`${baseURL}${employee.profile_image}`}
                                                    alt="Profile"
                                                    preview={!isDefaultProfileImage}
                                                />
                                                <h5 className="profile_name text_purple">
                                                    {(employee?.first_name || employee?.last_name)
                                                        ? `${employee?.first_name ?? ''} ${employee?.last_name ?? ''}`.trim()
                                                        : ''
                                                    }
                                                </h5>
                                                <h6 className="profile_role">{employee.role_name}</h6>
                                            </div>

                                            <div className="profile_view_tab_area">
                                                <div className="profile_view_tabs" id="profileViewTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('personal')}
                                                        id="personal-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#personal-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="personal-detail"
                                                        aria-selected={tab === 'personal'}
                                                    >
                                                        Personal
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    {employee?.contactSubType !== 'Temporary Employee' && (
                                                        <React.Fragment>
                                                            <button
                                                                className={`profile_view_tab_btn p-ripple ${tab === 'company' ? 'active' : ''}`}
                                                                onClick={() => switchTabs('company')}
                                                                id="company-detail-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#company-detail"
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="company-detail"
                                                                aria-selected={tab === 'company'}
                                                            >
                                                                Company
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>

                                                            <button
                                                                className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                                onClick={() => switchTabs('role')}
                                                                id="role-detail-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#role-detail"
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="role-detail"
                                                                aria-selected={tab === 'role'}
                                                            >
                                                                Role
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_view_area">
                                            {isPermissionUpdate && <button className="profile_edit_btn main p-ripple" onClick={() => setShowEditModal(true)}>
                                                <i className="bi bi-pencil-square"></i>
                                                <Ripple />
                                            </button>}
                                            <div className="tab-content profile_view_tab_content" id="profileViewTabContent">
                                                {/* Personal Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'personal' ? 'show active' : ''}`} id="personal-detail" role="tabpanel" aria-labelledby="personal-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* First name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">First name</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.first_name ? (
                                                                        <p>{employee.first_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">First name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Last name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Last name</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.last_name ? (
                                                                        <p>{employee.last_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Last name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Area */}
                                                        {(employee?.contactSubType === 'Area Manager' || employee?.contactSubType === 'Building Inspector') && (
                                                            <div className="col-12 col-xl-6 col-sm-6">
                                                                <div className="page_form_group">
                                                                   
                                                                    <label className="custom_form_label">Area {employee?.area_list?.length}</label>
                                                                    <div className="form_data_view_box">
                                                                        {employee?.area_list && employee?.area_list?.length !== 0 ? (
                                                                            <p>{employee?.area_list[0]?.area_name}</p>
                                                                        ) : (
                                                                            <span className="placeholder_text">Area</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Email</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.email ? (
                                                                        <Link
                                                                            to={`mailto:${employee?.email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail"
                                                                        >
                                                                            {employee.email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Mobile</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.mobile ? (
                                                                        <Link
                                                                            to={`tel:${employee?.mobile}`}
                                                                            className="text_no_wrap is_link is_contact_element phone"
                                                                        >
                                                                            {employee.mobile}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Mobile</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Landline</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.landline ? (
                                                                        <Link
                                                                            to={`tel:${employee?.landline}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {employee.landline}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Landline</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-12">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Address</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.address ? (
                                                                        <p>{employee.address}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.city ? (
                                                                        <p>{employee.city}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.post_code ? (
                                                                        <p>{employee.post_code}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Company Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'company' ? 'show active' : ''}`} id="company-detail" role="tabpanel" aria-labelledby="company-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Company personal email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company personal email</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.personal_email ? (
                                                                        <Link
                                                                            to={`mailto:${employee?.personal_email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail">
                                                                            {employee.personal_email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company personal email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Company personal phone */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company personal phone</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.personal_phone ? (
                                                                        <Link
                                                                            to={`tel:${employee?.personal_phone}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {employee.personal_phone}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company personal phone</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Company name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company name</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.companyName ? (
                                                                        <p>{employee.companyName}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Reg. no */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Reg. no</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.regno ? (
                                                                        <p>{employee.regno}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Reg. no</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Company email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company email</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.company_email ? (
                                                                        <Link
                                                                            to={`mailto:${employee?.company_email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail">
                                                                            {employee.company_email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Company phone */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company phone</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.company_phone ? (
                                                                        <Link
                                                                            to={`tel:${employee?.company_phone}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {employee.company_phone}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company phone</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Address</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.company_address ? (
                                                                        <p>{employee.company_address}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.company_city ? (
                                                                        <p>{employee.company_city}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.company_post_code ? (
                                                                        <p>{employee.company_post_code}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Role Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'role' ? 'show active' : ''}`} id="role-detail" role="tabpanel" aria-labelledby="role-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Role name</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.role_name ? (
                                                                        <p>{employee.role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Role name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Display role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Display role name</label>
                                                                <div className="form_data_view_box">
                                                                    {employee?.display_role_name ? (
                                                                        <p>{employee.display_role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Display role name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact edit modal */}
                        <Dialog
                            header={editModalHeader}
                            headerClassName="custom_modal_header"
                            footer={editModalFooter}
                            visible={showEditModal}
                            className="custom_modal_dialog modal_dialog_lg"
                            onHide={() => { if (!showEditModal) return; setShowEditModal(false); }}
                        >
                            <div className="custom_modal_body custom">
                                <div className="row">
                                    <div className="col-12 col-xl-4 page_divider">
                                        <div className="profile_edit_area">
                                            {tab === 'personal' ? (
                                                <React.Fragment>
                                                    <div className="form_img_upload_area pt-0">
                                                        <div className="form_img_upload">
                                                            <input
                                                                type="file"
                                                                accept={imageFileExtension}
                                                                className="form_img_upload_input"
                                                                id="profileImage"
                                                                onChange={handleImageChange}
                                                            />
                                                            <div className="form_img_upload_label_area">
                                                                <label
                                                                    htmlFor="profileImage"
                                                                    className={`form_img_upload_label ${profileImage ? 'uploaded' : ''}`}
                                                                    style={{ backgroundImage: profileImage ? `url(${profileImage})` : employee?.profile_image ? `url(${baseURL + employee?.profile_image})` : '' }}
                                                                >
                                                                    {(!profileImage && employee?.profile_image === null) && (
                                                                        <div className="upload_icon">
                                                                            <i className="bi bi-camera-fill"></i>
                                                                        </div>
                                                                    )}
                                                                </label>

                                                                {(profileImage || employee?.profile_image) && (
                                                                    <label htmlFor="profileImage" className="upload_update_icon">
                                                                        <i className="bi bi-camera-fill"></i>
                                                                    </label>
                                                                )}
                                                            </div>
                                                            {profileImage ? (
                                                                <React.Fragment>
                                                                    <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                                    {profileImageFile && (
                                                                        <button className="upload_clear_button mt-2" onClick={clearImage}>Remove</button>
                                                                    )}
                                                                </React.Fragment>
                                                            ) : employee?.profile_image ? (
                                                                <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                            ) : (
                                                                <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {errorProfileImageFile &&
                                                        <small className="form_error_msg text-center mt-2">{errorProfileImageFile}</small>
                                                    }
                                                </React.Fragment>
                                            ) : (
                                                <div className="profile_view_main_area mb-4">
                                                    <Image
                                                        className="profile_img_area custom"
                                                        src={`${baseURL}${employee.profile_image}`}
                                                        alt="Profile"
                                                        preview={!isDefaultProfileImage}
                                                    />

                                                    <h5 className="profile_name text_purple">
                                                        {(employee?.first_name || employee?.last_name)
                                                            ? `${employee?.first_name ?? ''} ${employee?.last_name ?? ''}`.trim()
                                                            : ''
                                                        }
                                                    </h5>
                                                    <h6 className="profile_role">{employee.role_name}</h6>
                                                </div>
                                            )}

                                            <div className="profile_edit_tab_area">
                                                <div className="profile_view_tabs" id="profileEditTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('personal')}
                                                        id="personal-edit-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#personal-edit-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="personal-edit-detail"
                                                        aria-selected={tab === 'personal'}
                                                    >
                                                        Personal
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    {employee?.contactSubType !== 'Temporary Employee' && (
                                                        <React.Fragment>
                                                            <button
                                                                className={`profile_view_tab_btn p-ripple ${tab === 'company' ? 'active' : ''}`}
                                                                onClick={() => switchTabs('company')}
                                                                id="company-edit-detail-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#company-edit-detail"
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="company-edit-detail"
                                                                aria-selected={tab === 'company'}
                                                            >
                                                                Company
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>

                                                            <button
                                                                className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                                onClick={() => switchTabs('role')}
                                                                id="role-edit-detail-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#role-edit-detail"
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="role-edit-detail"
                                                                aria-selected={tab === 'role'}
                                                            >
                                                                Role
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_edit_area edit_form">
                                            <div className="tab-content profile_view_tab_content" id="profileEditTabContent">
                                                {/* Edit Personal detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'personal' ? 'show active' : ''}`}
                                                    id="personal-edit-detail" role="tabpanel" aria-labelledby="personal-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* First name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                                <InputText
                                                                    id="firstName"
                                                                    value={firstName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="First name"
                                                                />

                                                                {firstNameError !== '' &&
                                                                    <small className="form_error_msg">{firstNameError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Last name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="lastName" className={`custom_form_label ${employeeType === 'Employee' ? 'is_required' : ''}`}>Last name</label>
                                                                <InputText
                                                                    id="lastName"
                                                                    value={lastName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Last name"
                                                                />

                                                                {lastNameError !== '' &&
                                                                    <small className="form_error_msg">{lastNameError}</small>
                                                                }
                                                            </div>
                                                        </div>


                                                        {/* Area */}
                                                        {(employee?.contactSubType === 'Area Manager' || employee?.contactSubType === 'Building Inspector') && (
                                                            <div className="col-12 col-xl-6 col-sm-6">
                                                                <div className="page_form_group">
                                                                    <label
                                                                        htmlFor="area"
                                                                        className="custom_form_label is_required"
                                                                    >
                                                                        Area
                                                                    </label>
                                                                    <div className="input_with_button_area">
                                                                        <InputText
                                                                            id="area"
                                                                            value={selectedArea ? selectedArea?.area_name : ''}
                                                                            className="custom_form_input has_add_value"
                                                                            placeholder="Click to select the area."
                                                                            readOnly={true}
                                                                            autoComplete="off"
                                                                            onClick={handleAddArea}
                                                                        />
                                                                        <button
                                                                            className="add_value_btn p-ripple"
                                                                            onClick={handleAddArea}
                                                                        >
                                                                            {selectedArea === null ? (
                                                                                <React.Fragment>
                                                                                    <i className="bi bi-plus-lg"></i>
                                                                                    <span>Add</span>
                                                                                </React.Fragment>
                                                                            ) : (
                                                                                <React.Fragment>
                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                    <span>Change</span>
                                                                                </React.Fragment>
                                                                            )}
                                                                            <Ripple />
                                                                        </button>
                                                                    </div>

                                                                    {errorArea && (
                                                                        <small className="form_error_msg">{errorArea}</small>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}


                                                        {/* Email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            {employeeType === 'Employee' ? (
                                                                <div className="page_form_group">
                                                                    <label htmlFor="email" className={`custom_form_label ${employeeType === 'Employee' ? 'is_required' : ''}`}>Email</label>

                                                                    <div className="input_search_group">
                                                                        <InputText
                                                                            id="email"
                                                                            value={email}
                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                            className="custom_form_input"
                                                                            placeholder="Email"
                                                                            disabled
                                                                        />

                                                                        {!email ? (
                                                                            <button
                                                                                className="input_grp_btn primary pos_abs p-ripple"
                                                                                onClick={() => setShowSearchEmailModal(true)}>
                                                                                <i className="bi bi-search"></i>
                                                                                <Ripple />
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                className="input_grp_btn danger pos_abs p-ripple"
                                                                                onClick={() => setEmail('')}>
                                                                                <i className="bi bi-x-lg"></i>
                                                                                <Ripple />
                                                                            </button>
                                                                        )}
                                                                    </div>

                                                                    {emailError !== '' &&
                                                                        <small className="form_error_msg">{emailError}</small>
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className="page_form_group">
                                                                    <label htmlFor="email" className={`custom_form_label ${employeeType === 'Employee' ? 'is_required' : ''}`}>Email</label>
                                                                    <InputText
                                                                        id="email"
                                                                        value={email}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                        className="custom_form_input"
                                                                        placeholder="Email"
                                                                    />

                                                                    {emailError !== '' &&
                                                                        <small className="form_error_msg">{emailError}</small>
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="mobile" className={`custom_form_label ${employeeType === 'Temporary Employee' ? 'is_required' : ''}`}>Mobile</label>
                                                                <InputText
                                                                    id="mobile"
                                                                    value={mobile}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobile(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Mobile"
                                                                />

                                                                {mobileError !== '' &&
                                                                    <small className="form_error_msg">{mobileError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="landline" className="custom_form_label">Landline</label>
                                                                <InputText
                                                                    id="landline"
                                                                    value={landline}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Landline"
                                                                />

                                                                {landlineError !== '' &&
                                                                    <small className="form_error_msg">{landlineError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="address" className={`custom_form_label ${employeeType === 'Employee' ? 'is_required' : ''}`}>Address</label>
                                                                <InputText
                                                                    id="address"
                                                                    value={address}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Address"
                                                                />

                                                                {addressError !== '' &&
                                                                    <small className="form_error_msg">{addressError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="city" className={`custom_form_label ${employeeType === 'Employee' ? 'is_required' : ''}`}>City</label>
                                                                <InputText
                                                                    id="city"
                                                                    value={city}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="City"
                                                                />

                                                                {cityError !== '' &&
                                                                    <small className="form_error_msg">{cityError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="postCode" className={`custom_form_label ${employeeType === 'Employee' ? 'is_required' : ''}`}>Post code</label>
                                                                <InputText
                                                                    id="postCode"
                                                                    value={postCode}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Post code"
                                                                />

                                                                {postCodeError !== '' &&
                                                                    <small className="form_error_msg">{postCodeError}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Edit Company detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'company' ? 'show active' : ''}`}
                                                    id="company-edit-detail" role="tabpanel" aria-labelledby="company-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Company personal email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyPersonalEmail" className="custom_form_label">Company personal email</label>
                                                                <InputText
                                                                    id="companyPersonalEmail"
                                                                    value={companyPersonalEmail}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPersonalEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company personal email"
                                                                />

                                                                {companyPersonalEmailError !== '' &&
                                                                    <small className="form_error_msg">{companyPersonalEmailError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Company personal phone */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyPersonalPhone" className="custom_form_label">Company personal phone</label>
                                                                <InputText
                                                                    id="companyPersonalPhone"
                                                                    value={companyPersonalPhone}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPersonalPhone(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company personal phone"
                                                                />

                                                                {companyPersonalPhoneError !== '' &&
                                                                    <small className="form_error_msg">{companyPersonalPhoneError}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className="mt-0 mb-4" />

                                                    <div className="row">
                                                        {/* Company name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyName" className="custom_form_label">Company name</label>
                                                                <InputText
                                                                    id="companyName"
                                                                    value={companyName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company name"
                                                                />

                                                                {companyNameError !== '' &&
                                                                    <small className="form_error_msg">{companyNameError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Reg. no. */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyRegNo" className="custom_form_label">Reg. no.</label>
                                                                <InputText
                                                                    id="companyRegNo"
                                                                    value={companyRegNo}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNo(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Reg. no."
                                                                />

                                                                {companyRegNoError !== '' &&
                                                                    <small className="form_error_msg">{companyRegNoError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Company email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyEmail" className="custom_form_label">Company email</label>
                                                                <InputText
                                                                    id="companyEmail"
                                                                    value={companyEmail}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company email"
                                                                />

                                                                {companyEmailError !== '' &&
                                                                    <small className="form_error_msg">{companyEmailError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Company phone */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyPhone" className="custom_form_label">Company phone</label>
                                                                <InputText
                                                                    id="companyPhone"
                                                                    value={companyPhone}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPhone(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company phone"
                                                                />

                                                                {companyPhoneError !== '' &&
                                                                    <small className="form_error_msg">{companyPhoneError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyAddress" className="custom_form_label">Address</label>
                                                                <InputText
                                                                    id="companyAddress"
                                                                    value={companyAddress}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddress(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Address"
                                                                />

                                                                {companyAddressError &&
                                                                    <small className="form_error_msg">{companyAddressError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyCity" className="custom_form_label">City</label>
                                                                <InputText
                                                                    id="companyCity"
                                                                    value={companyCity}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyCity(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="City"
                                                                />

                                                                {companyCityError !== '' &&
                                                                    <small className="form_error_msg">{companyCityError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyPostCode" className="custom_form_label">Post code</label>
                                                                <InputText
                                                                    id="companyPostCode"
                                                                    value={companyPostCode}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPostCode(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Post code"
                                                                />

                                                                {companyPostCodeError &&
                                                                    <small className="form_error_msg">{companyPostCodeError}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Edit Role detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'role' ? 'show active' : ''}`}
                                                    id="role-edit-detail" role="tabpanel" aria-labelledby="role-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <div className="w-100">
                                                                    <label htmlFor="role" className="custom_form_label is_required">Role name</label>
                                                                    <Dropdown
                                                                        value={selectedRole}
                                                                        id="role"
                                                                        onChange={(e: DropdownChangeEvent) => setSelectedRole(e.value)}
                                                                        options={roleList}
                                                                        optionLabel="role_name"
                                                                        valueTemplate={selectedRoleTemplate}
                                                                        itemTemplate={roleOptionTemplate}
                                                                        placeholder="Select role"
                                                                        className="form_dropdown w-100"
                                                                        showClear
                                                                    />

                                                                    {selectedRoleError !== '' &&
                                                                        <small className="form_error_msg">{selectedRoleError}</small>
                                                                    }
                                                                </div>

                                                                <div className="add_data_area">
                                                                    {isPermissionAdd && <button className={`add_data_btn ${showAddData ? 'danger' : ''} p-ripple`} onClick={toggleAddData}>
                                                                        <i className={`bi ${showAddData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                                        {showAddData ? (<span>Cancel</span>)
                                                                            : (<span>Add role</span>)
                                                                        }
                                                                        < Ripple />
                                                                    </button>}

                                                                    <div className={`add_data_input_area ${showAddData ? 'show' : ''}`}>
                                                                        <InputText
                                                                            id="roleName"
                                                                            value={addRoleName}
                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddRoleName(e.target.value)}
                                                                            className="custom_form_input"
                                                                            placeholder="Enter role name"
                                                                        />

                                                                        <Button
                                                                            label="Add"
                                                                            className="ps-4 pe-4"
                                                                            onClick={handleAddRole}
                                                                        />
                                                                    </div>
                                                                    {addRoleNameError !== '' && (
                                                                        <small className="form_error_msg">{addRoleNameError}</small>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Display role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="displayRoleName" className="custom_form_label is_required">Display role name</label>
                                                                <InputText
                                                                    id="displayRoleName"
                                                                    value={displayRoleName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Display role name"
                                                                />

                                                                {displayRoleNameError !== '' &&
                                                                    <small className="form_error_msg">{displayRoleNameError}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>


                        {/* Email search modal */}
                        <EmailSearchDialog
                            visible={showSearchEmailModal}
                            contactSubtype="Employee"
                            onHide={() => setShowSearchEmailModal(false)}
                            onEmailConfirm={(email) => onEmailConfirm(email)}
                        />
                        {/*  */}


                        {/* Area list modal */}
                        <Dialog
                            visible={showAreaModal}
                            headerClassName="d-none"
                            dismissableMask
                            className="custom_modal_dialog modal_dialog_sm data_select_modal"
                            contentClassName="data_select_modal_content"
                            onHide={handleCloseAreaModal}
                        >
                            <div className="custom_modal_body data_select_modal_area">
                                <div className="data_select_modal_header">
                                    <div className="data_search_input_area">
                                        <InputText
                                            key={"areaSearchKey"}
                                            id="areaSearchKey"
                                            value={areaSearchKey}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                setAreaSearchKey(e.target.value)
                                            }
                                            className="custom_form_input data_search_input"
                                            placeholder="Search area by name"
                                            autoComplete="off"
                                            autoFocus
                                            type={"search"}
                                        />
                                        {areaSearchKey === "" ? (
                                            <i className="bi bi-search"></i>
                                        ) : (
                                            <i
                                                className="bi bi-x-lg data_search_input_clear"
                                                onClick={() => setAreaSearchKey("")}
                                            ></i>
                                        )}
                                    </div>

                                    <button
                                        type="button"
                                        className="data_select_modal_close p-ripple"
                                        onClick={handleCloseAreaModal}
                                    >
                                        <i className="bi bi-x"></i>
                                        <Ripple />
                                    </button>
                                </div>

                                <div className="data_select_modal_body has_custom_input">
                                    {filteredAreaListData && filteredAreaListData?.length > 0 ? (
                                        <div className="data_select_option_area">
                                            {filteredAreaListData?.map((area) => (
                                                <div
                                                    key={area?.id}
                                                    className={`data_select_option has_edit p-ripple ${area?.id === selectedArea?.id ? "selected" : ""}`}
                                                    onClick={() => handleSelectArea(area)}
                                                >
                                                    {area?.area_name}

                                                    <button className="is_btn data_select_option_edit_btn p-ripple"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEditArea(area);
                                                        }}>
                                                        <i className="bi bi-pencil-square"></i>
                                                    </button>

                                                    <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="no_records_found">
                                            <i className="bi bi-exclamation-circle me-1"></i>
                                            No data found.
                                        </div>
                                    )}
                                </div>

                                <div className="page_form_group data_select_modal_footer mb-0">
                                    <div className="input_with_button_area">
                                        <InputText
                                            id="customAreaName"
                                            value={customAreaName}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                setCustomAreaName(e.target.value)
                                            }
                                            className="custom_form_input has_add_value custom_data_input"
                                            placeholder="Enter area name"
                                            autoComplete="off"
                                        />
                                        <button
                                            className="add_value_btn fill p-ripple"
                                            onClick={handleCreateArea}
                                            disabled={customCreateLoading || customAreaName === ""}
                                        >
                                            {customCreateLoading ? (
                                                <span>Processing</span>
                                            ) : (
                                                <React.Fragment>
                                                    <i className="bi bi-plus-lg"></i>
                                                    <span>Add</span>
                                                </React.Fragment>
                                            )}
                                            <Ripple />
                                        </button>
                                    </div>
                                    {customAreaNameError && (
                                        <small className="form_error_msg">{customAreaNameError}</small>
                                    )}
                                </div>
                            </div>
                        </Dialog>
                        {/*  */}


                        {/* Area edit modal */}
                        <Dialog
                            visible={showAreaEditModal}
                            headerClassName="custom_modal_header"
                            header={areaEditModalHeader}
                            footer={areaEditModalFooter}
                            dismissableMask
                            className="custom_modal_dialog modal_dialog_xsm"
                            onHide={handleCloseAreaEditModal}
                        >
                            <div className="custom_modal_body">
                                <div className="p-1 w-100">
                                    <div className="row">
                                        <div className="col-12">
                                            <TextInput
                                                key={`areaName`}
                                                id="areaName"
                                                label="Area"
                                                labelHtmlFor="areaName"
                                                required={true}
                                                value={areaName}
                                                inputType="text"
                                                placeholder="Area"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAreaName(e.target.value)}
                                                error={areaNameError}
                                                formGroupClassName="mb-2"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>
                        {/*  */}
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    )
}

export default ViewEmployeeContact;